import { styled } from '@mui/system';
import { Typography, Box, Grid2 } from '@mui/material';

export const TypographyStyledHeader = styled(Typography)(({ theme }) => ({
  color: theme?.palette?.primaryDark,
  fontSize: '1.625rem',
  fontWeight: 450
}));

export const BoxStyled = styled(Box)({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center'
});

export const GridStyled = styled(Grid2)({
  padding: '1rem',
  display: 'flex',
  flexDirection: 'column',
  width: '100%'
});

export const GridStyledDOB = styled(Grid2)({
  display: 'flex',
  flexDirection: 'row',
  paddingTop: '0.625rem',
  width: '100%'
});
